import React from 'react';
import { RegisterOptions } from 'react-hook-form/dist/index.ie11';
import { BaseEmailInput } from 'src/components/BaseEmailInput/BaseEmailInput';

export interface BusinessEmailControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
  disabled?: boolean;
}

export function BusinessEmailControl({
  name,
  id,
  rules,
  disabled,
}: BusinessEmailControlProps): JSX.Element {
  return (
    <BaseEmailInput
      name={name}
      id={id}
      label="Business email"
      rules={rules}
      placeholder=""
      disabled={disabled}
    />
  );
}
